import axios from "axios";
import { getCurrentSessionIdToken  } from "../cognito/cognitoCookie";
import { UserCapabilitiesApiResponse } from "../types/inspections/UserCapabilities";

export interface GetUserInfoRequestData {
    userId: string;
}

export interface GetUserCapabilitiesRequestData {
    userId: string;
}

export const getHeader = async () => {
    const token = await getCurrentSessionIdToken();

    return {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + token
    }
}


export const getUserInfo = async (userId: string | undefined) => {
    if (userId) {
        const apiBaseUrl = process.env.REACT_APP_IDWAL_API_URL;
        const jwtToken = await getCurrentSessionIdToken();

        const api = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`
            }
        });

        try {
            const apiResponse = await api.get(`/Users/${userId}/Info`);

            return apiResponse.data.data;
        } catch (error) {
            return null;
        }
    }

    return null;
};

export const getUserCanAccessInspection = async (userId: string | undefined, inspectionId: string | undefined) => {
    if (inspectionId === "TEST ID") {
        return true;
    }

    if (userId && inspectionId) {
        const apiBaseUrl = process.env.REACT_APP_IDWAL_API_URL;
        const jwtToken = await getCurrentSessionIdToken();

        const api = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`
            }
        });

        try {
            const apiResponse = await api.get(`/Inspection/userCanAccess/${inspectionId}/${userId}`);

            return apiResponse.status === 200;
        } catch (error) {
            console.log(error)
            return false;
        }
    }

    return false;
};

export const getUserCapabilities = async (userId: string | undefined) => {
    if (userId) {
        const url = process.env.REACT_APP_IDWAL_API_URL + `/Users/${userId}/Capabilities?app=FleetApp`;

        const headers = await getHeader();

        const data = { userId, app: process.env.REACT_APP_FLEET_APP_GROUP };

        try {
            const response = await axios.get<UserCapabilitiesApiResponse>(url, { headers, data });

            if (response.data.data?.length) {
                return response.data.data;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }
    return [];
}
